import React, { Dispatch, SetStateAction, useContext, useEffect, useMemo, useRef } from "react";
import ApiMessage, { TMessageItem } from "../../modules/api/message";
import ModuleDate from "../../modules/date";
import { LABEL_ANONYMOUS_USER } from "../../config/constants";
import AppUserContext from "../../context/app-user-context";
import { Link } from "react-router-dom";
import { HiPencil } from "react-icons/hi";
import { nl2br } from "../../utils/jquery-helper";

export type TFeedbackItemsProps = {
  hideEditButton?: boolean;
  messages: TMessageItem[];
  refreshMessages: Dispatch<SetStateAction<boolean>>;
  labelUnavailable?: string;
  hideTraitLabel?: boolean;
  onClickEdit?: (...params: any) => any;
};

FeedbackItems.defaultProps = {
  labelUnavailable: "Feedback not available.",
  onClickEdit: () => {}
}

export default function FeedbackItems(props: TFeedbackItemsProps) {
  const user = useContext(AppUserContext);
  const itemRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute("data-id");
            if (id) {
              ApiMessage.submissionReadStatus(id);
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { threshold: 0.5 }
    );
    Object.values(itemRefs.current).forEach((el) => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [props.messages]);

  const messages = useMemo(() => {
    return props.messages.map(message => <React.Fragment key={message._id}>
      <div className="feedback-item"
        ref={(el) => (itemRefs.current[message._id] = el)}
        data-id={message._id}>
        {message.anonymous && <h1>{LABEL_ANONYMOUS_USER}</h1>}
        {!message.anonymous && <h1>{message.senderName}</h1>}
        <div className="feedback-item__sub-title">
          {!props.hideEditButton && user && user.referenceUserId === message.senderId && user.role === message.messageType && <>
            <Link to={""} onClick={(e) => {
              e.preventDefault();
              props.onClickEdit(e);
            }}><HiPencil/> Edit</Link> | {" "}
          </>}
          {!props.hideTraitLabel && <>{message?.trait?.name ?? "Unknown trait"} | </>}{ModuleDate.getTitleFormat(message.createdDate)}
          {message.status === "Draft" && <> | <span className="draft-message col-secondary">DRAFT</span></>}
        </div>
        <div className="feedback-item__content" dangerouslySetInnerHTML={{ __html: nl2br(message?.message) }}></div>
      </div>
    </React.Fragment>)
  }, [props.messages]);

  return <div className="feedback-items">
    {props.messages.length === 0 && <p className="alert alert-not-found">
      {props.labelUnavailable}
    </p>}

    {messages}
  </div>;
}
